module.exports = __webpack_public_path__ + "img/uniswap.2ae3f49b.jpeg";